import { render } from "./Navbar_mobile.vue?vue&type=template&id=0c1961ea"
import script from "./Navbar_mobile.vue?vue&type=script&lang=js"
export * from "./Navbar_mobile.vue?vue&type=script&lang=js"
script.render = render

export default script